import { QuestionType } from './base/types'
import { type TextMessage } from './i18n'
import { QuestionObject } from './question_object'

export class NumericQuestion extends QuestionObject<number> {
  constructor (id: string, title: TextMessage) {
    super(id, QuestionType.Numeric, title)
  }
}
